import { menusForShell } from "@/app/menus";
import { iconForNavGroup } from "@/app/nav/navIcons";
import type { OpsNavGroup, OpsNavLeaf } from "@/app/nav/types";
import { hasAnyPermission } from "@/shared/auth/permissions";

/**
 * Emergency FE nav builder — only when `VITE_NAV_SOURCE=legacy` (W5 hard cut).
 * Production SoT is BE published snapshot via `useOpsNav`.
 * Order constants removed; emergency path sorts by label.
 */
export function buildLegacyOpsNav(permissions: readonly string[]): OpsNavGroup[] {
  const screens = menusForShell("ops").filter((s) => {
    if (s.permissions.length === 0) return true;
    return hasAnyPermission(permissions, s.permissions);
  });

  const byGroup = new Map<string, OpsNavLeaf[]>();
  for (const s of screens) {
    const g = s.menuGroup ?? "Khác";
    const list = byGroup.get(g) ?? [];
    list.push({ screenId: s.screenId, path: s.path, label: s.label });
    byGroup.set(g, list);
  }

  return [...byGroup.entries()]
    .sort((a, b) => a[0].localeCompare(b[0], "vi"))
    .map(([label, children]) => ({
      id: label.toLowerCase().replace(/\s+/g, "-"),
      label,
      icon: iconForNavGroup(null, label),
      children: [...children].sort((a, b) =>
        a.label.localeCompare(b.label, "vi"),
      ),
    }));
}
